import { render, staticRenderFns } from "./DashboardDesign.vue?vue&type=template&id=20fdc68c"
import script from "./DashboardDesign.vue?vue&type=script&lang=js"
export * from "./DashboardDesign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports